module.exports = __webpack_public_path__ + "static/img/hezuo08.f38bcc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/imgsrc/hezuo08.jpg
// module id = yhWk
// module chunks = 1